import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RestApiService } from '../angular-service/helper.httpServices';
import { LocalStorageService } from '../angular-service/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private endPoint =
    environment.wordPressApiUrl + environment.wordPressApiEndPoint;
  constructor(
    private http: RestApiService,
    private localStorage: LocalStorageService
  ) {}
  pageCategoriesList = 1;
  categoriesList: any = [];
  storeCategoryData() {
    // let categoriesList = this.localStorage.getItem("Categories");
    // if (!categoriesList) {
    this.getCategories(this.pageCategoriesList)
      .then((data: any) => {
        if (data.length > 0) {
          let result = data.map((item: any) => {
            // delete item.yoast_head;
            delete item._links;
            delete item.meta;
            delete item.link;
            return item;
          });
          this.categoriesList = [...this.categoriesList, ...result];
          this.pageCategoriesList = this.pageCategoriesList + 1;
          this.storeCategoryData();
        } else {
          this.localStorage.setItem(
            'Categories',
            JSON.stringify(this.categoriesList)
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCategories(page: any) {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(this.endPoint + 'categories?per_page=100&page=' + page)
        .subscribe(
          (response) => {
            this.localStorage.setItem('Categories', JSON.stringify(response));
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getCategory(id: any) {
    return new Promise((resolve, reject) => {
      let cat = this.getCatByIdLocalStorage(id);
      if (!cat) {
        this.http.get<any>(this.endPoint + 'categories/' + id).subscribe(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
      } else {
        resolve(cat);
      }
    });
  }

  getCatByIdLocalStorage(id: any) {
    let categoriesData = this.localStorage.getItem('Categories');
    var category: any = null;
    if (categoriesData) {
      let catList = JSON.parse(categoriesData);
      catList.forEach((cat: any) => {
        if (cat.id == id) {
          category = cat;
        }
      });
      return category;
    } else {
      return category;
    }
  }

  getCatSlugFromLocalStorage(slug: any) {
    let categoriesData = JSON.parse(this.localStorage.getItem('Categories'));
    var category: any = null;
    if (categoriesData) {
      let catList = categoriesData;
      catList.forEach((cat: any) => {
        if (cat.slug == slug) {
          category = cat;
        }
      });
      return category;
    } else {
      return category;
    }
  }

  getCategoriesFromLocalStorage() {
    return  JSON.parse(this.localStorage.getItem('Categories'));
  }
}
